import React, { useEffect, useReducer } from 'react';

// CSS
import styles from '@UILayer/UILayer.scss';

import TextField from '@UILayer/Inputs/TextField/TextField';
import { IPaytableSymbolDescription } from './Paytable.types';

const PaytableSymbolDescription: React.FC<IPaytableSymbolDescription> = ({ paytableData, paytableIndex, maxStringData, textFieldCallback }) => {
    const [state, setState] = useReducer((state: {}, newState: any) => ({ ...state, ...newState }), {});

    useEffect(() => {}, [paytableData, maxStringData]);

    return (
        <>
            {paytableData?.dom.map((val, index) => {
                return (
                    <div className={styles.paytable_item_info_item} key={index}>
                        {index === 0 && paytableIndex === maxStringData.block ? (
                            <TextField onResizeEnd={(value: number) => textFieldCallback(value)}>{val.lineString}</TextField>
                        ) : (
                            <div>{val.lineString}</div>
                        )}
                    </div>
                );
            })}
        </>
    );
};

export default PaytableSymbolDescription;
